export default "__VITE_ASSET__BAfigMtD__"